import React from 'react';

import { SvgIcon as MuiSvgIcon } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

export type IconSize = 'xs' | 's' | 'm' | 'l' | 'xl' | undefined;

export interface IconProps {
  children?: React.ReactNode;
  className?: string;
  enclosed?: boolean;
  size?: IconSize;
  stroke?: boolean;
  testId?: string;
  viewBox?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  svgIcon: {
    color: theme.palette.common.black,
    display: 'block',
    fill: 'none',
  },
  xs: {
    fontSize: 16,
  },
  s: {
    fontSize: 24,
  },
  m: {
    fontSize: 36,
  },
  l: {
    fontSize: 48,
  },
  xl: {
    fontSize: 96,
  },

  enclosed: {
    alignItems: 'center',
    backgroundColor: theme.palette.grey[200],
    borderRadius: 48,
    display: 'flex',
    justifyContent: 'center',

    '&.xs': {
      padding: theme.spacing(1),
    },
    '&.s': {
      padding: theme.spacing(1),
    },
    '&.m': {
      padding: theme.spacing(2),
    },
    '&.l': {
      padding: theme.spacing(2),
    },
    '&.xl': {
      padding: theme.spacing(3),
    },
  },
}));

export const SvgIcon = (props: IconProps): JSX.Element => {
  const {
    children,
    className = '',
    enclosed = false,
    size = 's',
    stroke = false,
    testId = '',
    viewBox,
    ...rest
  } = props;

  const classes = useStyles();
  const enclosedStyle = clsx(
    'fd-icon',
    enclosed && classes.enclosed,
    className && className,
    size === 'xs' && 'xs',
    size === 's' && 's',
    size === 'm' && 'm',
    size === 'l' && 'l',
    size === 'xl' && 'xl',
  );
  const svgIconStyles = clsx(
    classes.svgIcon,
    className !== '' && className,
    size === 'xs' && classes.xs,
    size === 's' && classes.s,
    size === 'm' && classes.m,
    size === 'l' && classes.l,
    size === 'xl' && classes.xl,
  );

  return (
    <div className={enclosedStyle}>
      <MuiSvgIcon
        aria-hidden="true"
        className={svgIconStyles}
        {...(testId && { 'data-fd': testId })}
        {...(stroke && { stroke: 'currentColor' })}
        viewBox={viewBox}
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        {children}
      </MuiSvgIcon>
    </div>
  );
};
